// Make sure to register before importing any components
import './class-component-hooks';
import PortalVue from 'portal-vue';
import Vidle from 'v-idle';
import Vue from 'vue';
// eslint-disable-next-line import/no-named-as-default
import VueCurrencyInput, { CurrencyInputOptions, } from 'vue-currency-input';
import { SelfServeApiPlugin, } from '~/api/self-serve-api';
import type { ConfigValueAccessor, } from '~/utils/self-serve/global-config';
import { loadGlobalConfig, } from '~/utils/self-serve/global-config';
import App from './app.vue';
import { AuthServicePlugin, } from './auth-service';
import { Router, } from './router';
import { Store, } from './store';
import type { CustomContentState, } from './store/custom-content';

import '~/assets/scss/self-serve.scss';
import '~/assets/scss/fontawesome.scss';

Vue.config.productionTip = false;

const currencyPluginOptions: CurrencyInputOptions = {
	allowNegative: false,
	autoDecimalMode: false,
	currency: undefined,
	distractionFree: {
		hideCurrencySymbol: true,
	},
};

Vue.use(VueCurrencyInput, {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	globalOptions: currencyPluginOptions,
});

const router = Router;

Vue.use(Vidle);
Vue.use(PortalVue);

export function Account(mountPoint: string | HTMLElement, configValueAccessor: ConfigValueAccessor, customContent: CustomContentState) {
	const globalConfig = loadGlobalConfig(configValueAccessor);
	Vue.use(SelfServeApiPlugin, {
		baseUrl: globalConfig.SelfServeApiAddress || '',
	});

	Vue.use(AuthServicePlugin, {
		router,
		store: Store,
	});

	Store.commit.hydrateGlobalConfig(globalConfig);
	Store.commit.customContent.hydrateCustomConfig(customContent);
	void Store.dispatch.init('Account');

	new Vue({
		router,
		render(h) {
			return h(App);
		},
		store: Store.original,
		onIdle() {
			if (Store.getters.isAuthenticated) {
				handleOverlay();
			}
		},
	}).$mount(mountPoint);
}

let tick: number | null = null;

window.addEventListener('beforeunload', () => clearTick());

function clearTick() {
	if (tick) {
		clearInterval(tick);
	}
}

export const handleOverlay = () => {
	let seconds = 3 * 60; // 3 minutes in seconds
	let timeRemaining = '';
	clearTick();

	tick = window.setInterval(() => {
		const minutes = Math.ceil(seconds / 60);
		let remainingSeconds:string | number = seconds % 60;
		if (remainingSeconds < 10) {
			remainingSeconds = `0${remainingSeconds}`;
		}
		if (Math.floor(seconds / 60) < 1) {
			timeRemaining = `${remainingSeconds} seconds`;
		} else {
			timeRemaining = minutes < 2 ? `${minutes} minute` : `${minutes} minutes`;
		}
		seconds--;
		if (seconds < 0) {
			clearTick();
			if (Store.state.businessPartnerDetails) {
				void Vue.authService.logout({ type: 'Warning', title: 'You’ve been logged out', body: 'Your session timed out due to inactivity. Please sign in again to continue.', });
			}
		}
		if (Store.state.isOverlayVisible) {
			Store.commit.updateOverlayMessage(timeRemaining);
		} else {
			clearTick();
		}
	}, 1000);

	Store.commit.showOverlay(
		{
			message: timeRemaining,
			isTimerOverlay: true,
		}
	);
};
